import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
import { auth } from '@/auth';
import Bugsnag from '@bugsnag/browser';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { unregisterServiceWorker } from '@/utils';

const apiKey = import.meta.env.VITE_BUGSNAG_KEY;

if (apiKey) {
  Bugsnag.start({
    apiKey,
    plugins: [new BugsnagPluginReact()],
    releaseStage: import.meta.env.MODE, // "development" | "production"
  });
}

const reactPlugin = Bugsnag.getPlugin('react');
const ErrorBoundary = reactPlugin?.createErrorBoundary(React) ?? React.Fragment;

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root');

createRoot(container).render(
  <ErrorBoundary>
    <App auth={auth} />
  </ErrorBoundary>
);

unregisterServiceWorker();
